export default [
    {
        key: 'ideal',
        label: 'Ideal',
        components: [
            {
                type: 'checkbox',
                label: 'Enable',
                key: 'ideal',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for iDeal payments.',
                defaultValue: true,
            },
            {
                type: 'checkbox',
                label: 'Enable for single payments',
                key: 'ideal_once',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for iDeal payments when frequency is set to "Once".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.ideal;
                }
            },
            {
                type: 'checkbox',
                label: 'Enable for monthly payments',
                key: 'ideal_monthly',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for iDeal payments when frequency is set to "Monthly".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.ideal;
                }
            },
            {
                type: 'checkbox',
                label: 'Enable for yearly payments',
                key: 'ideal_yearly',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for iDeal payments when frequency is set to "Yearly".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.ideal;
                }
            },
            {
                type: 'textfield',
                label: 'iDeal label',
                key: 'ideal_label',
                tooltip: 'Set the label for the iDeal option',
                input: true,
                allowCalculateOverride: 0,
                defaultValue: 'iDeal',
                weight: 30,
                customConditional: function customConditional(ctx) {
                    return ctx.data.ideal;
                }
            },
            {
                type: 'textfield',
                label: 'Bank label',
                key: 'bank_label',
                tooltip: 'Set the label for the bank select field',
                input: true,
                allowCalculateOverride: 0,
                defaultValue: '',
                weight: 40,
                customConditional: function customConditional(ctx) {
                    return ctx.data.ideal;
                },
            },
            {
                weight: 50,
                type: 'checkbox',
                input: true,
                key: 'show_bank_options',
                label: 'Edit bank options',
                customConditional: function customConditional(ctx) {
                    return ctx.data.ideal;
                },
            },
            {
                weight: 60,
                type: 'datagrid',
                input: true,
                key: 'banks',
                label: 'Bank options',
                customConditional: function customConditional(ctx) {
                    return ctx.data.show_bank_options && ctx.data.ideal;
                },
                reorder: true,
                defaultValue: [{
                        'label': 'ABN AMRO',
                        'value': 'ABNANL2A'
                    },
                    {
                        'label': 'ASN',
                        'value': 'ASNBNL21'
                    },
                    {
                        'label': 'bunq',
                        'value': 'BUNQNL2A'
                    },
                    {
                        'label': 'ING',
                        'value': 'INGBNL2A'
                    },
                    {
                        'label': 'Knab',
                        'value': 'KNABNL2H'
                    },
                    {
                        'label': 'Rabobank',
                        'value': 'RABONL2U'
                    },
                    {
                        'label': 'RegioBank',
                        'value': 'RBRBNL21'
                    },
                    {
                        'label': 'SNS',
                        'value': 'SNSBNL2A'
                    },
                    {
                        'label': 'Triodos',
                        'value': 'TRIONL2U'
                    },
                    {
                        'label': 'Van Lanschot',
                        'value': 'FVLBNL22'
                    }],
                components: [{
                        label: 'Label',
                        key: 'label',
                        input: true,
                        type: 'textfield',
                        validate: {
                            required: false
                        }
                    }, {
                        label: 'Issuer ID',
                        key: 'value',
                        input: true,
                        type: 'textfield',
                        allowCalculateOverride: false,
                        validate: {
                            required: false
                        }
                    }]
            },
        ]
    },
];
